import Backbone from 'backbone';
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import { BackboneViewProps } from '../../types';
import GongParentComponent from './ReactComponents/GongParentComponent';

const template = require('./index.pug');

export default (Backbone as any).Epoxy.View.extend({
  initialize(options: BackboneViewProps) {
    this.tenant = options.tenant;
    this.integration = 'gong';
    setTimeout(() => {
      this.render();
      this.renderGongIntegrationComponent();
    }, 250);
  },

  renderGongIntegrationComponent() {
    const containerDomElement = $('#GongParentComponentContainer')[0];

    if (typeof containerDomElement !== 'undefined') {
      ReactDOM.render(
        <GongParentComponent tenant={this.tenant} />,
        containerDomElement
      );
    }
  },

  render() {
    this.$el.empty();
    const html = template();
    this.$el.html(html);
  },
});
